import { Data } from "../../types/Data";
import { getObjectFromOptions } from "./getObjectFromOptions";

export function initDataFromDocument(): Data {
  return {
    "type-de-bien": getObjectFromOptions("filter-property-type"),
    "type-viager": getObjectFromOptions("filter-viager-type"),
    "nb-piece": getObjectFromOptions("filter-rooms"),
    "nb-chambre": getObjectFromOptions("filter-bedrooms"),
    annexes: getObjectFromOptions("filter-annexes"),
    accessibilite: getObjectFromOptions("filter-accessibility"),
    "type-chauffage": getObjectFromOptions("filter-heating-type"),
    dpe: getObjectFromOptions("filter-dpe"),
  };
}
